const UIFormValidateMinLength = (length, message = `Informe ao menos ${length} caracteres`) =>
  input => input && input.length < length ? message : undefined

export default UIFormValidateMinLength
